module.exports = __webpack_public_path__ + "img/14.7fc6c5c3.webp";